import { action } from "satcheljs";
import { IMemberEntity, ITagEntity } from "src/client/react/src/staffhub/sh-models";

const addMembers = action(
    "addMembers",
    (
        tag: ITagEntity,
        members: IMemberEntity[],
        onCloseClick?: () => void,
        userIds?: string[]
    ) => ({
        tag: tag,
        members: members,
        onCloseClick: onCloseClick,
        userIds: userIds
    })
);

export default addMembers;